<template>
  <div class="fill-height d-flex flex-column">
    <div class="grow pa-8 d-flex flex-column">
      <InstructionsBox
        v-if="instructions"
        :text="instructions"
      />

      <div class="grow">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'

import InstructionsBox from '@/components/Party/QuickInterview/InstructionsBox.vue'

export default {
  name: 'GenericStep',

  components: {
    InstructionsBox,
  },

  props: {
    // eslint-disable-next-line vue/no-unused-properties
    errorList: {
      type: Array,
      default: _ => [],
    },

    instructions: {
      type: String,
      default: '',
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
    }
  },

  computed: {
    errors () {
      return this.v$.$errors || []
    },
  },

  watch: {
    errors: {
      handler: function (value) { this.$emit('update:error-list', value || []) },
      immediate: true,
    },
  },
}
</script>
